import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserModel,CaptchaData } from '../../_models/user.model';
import { AuthModel, TokenRequest } from '../../_models/auth.model';
import { ActionResult,TOTransaction } from '../../_models/action-result';
import { ConfigService } from 'src/app/services/config.service';
import { resetpassword } from '../../_models/resetpassword';
import { catchError, delay, finalize, map, retryWhen, scan, tap } from 'rxjs/operators';
import { MicroApplication } from 'src/app/services/microapplications/_models/microapplication.model';
import { MessagesService } from 'src/app/services/service.index';

@Injectable({
	providedIn: 'root',
})
export class AuthHTTPService {
	isLoadingSubject: BehaviorSubject<boolean>;
	constructor(

		private http: HttpClient,
		private configService: ConfigService,
		private messagesService: MessagesService,
		
	
	) {    this.isLoadingSubject = new BehaviorSubject<boolean>(false);}

	// public methods
	login(user: string, password: string,valueatentication:string): Observable<any> {
		return this.http.post<ActionResult<any>>(
			`${this.configService.config.apiSecuritySeven}/login`,
			{ user, password,valueatentication }
		);
	}

	GetWidgets(){   
		return this.http
		  .get<ActionResult<MicroApplication[]>>(`${this.configService.config.apiMicroApplicationsSeven}/MicroApplications/GetWidgets`);
	  }

	doubleauthentication(code: string,intentos:number,user:string) {
		return this.http.get<ActionResult<any>>(
			`${this.configService.config.apiSecuritySeven}/login/validatedoubleauthenticatio?code=${code}&intentos=${intentos}&user=${user}`
		);
	
	}

	Getcapchat(){
		this.isLoadingSubject.next(true); // Si manejas un indicador de carga
		return this.http.get<ActionResult<any>>(
		  `${this.configService.config.apiSecuritySeven}/Getcapchat`
		).pipe(
		  retryWhen(errors =>
			errors.pipe(
			  scan((retryCount, error) => {
				if (retryCount >= 2) {
				  throw error;
				}
				return retryCount + 1;
			  }, 0),
			  tap(retryCount => console.log(`Intento de reintento ${retryCount} fallido en Getcapchat. Reintentando...`)),
			  delay(1000)
			)
		  ),
		  catchError(err => {
			this.messagesService.error("Error conectando con el servidor de seguridad");
			return of(null);
		  }),
		  map((resp: ActionResult<any>) => resp),
		  finalize(() => this.isLoadingSubject.next(false))
		);
	  }

	loadimgloggins(){

		return this.http.get<ActionResult<any>>(
			`${this.configService.config.apiSecuritySeven}/themes/Getimglogin`
		  ).pipe(
			retryWhen(errors =>
			  errors.pipe(
				// Acumula el número de reintentos
				scan((retryCount, error) => {
				  if (retryCount >= 2) {
					throw error;
				  }
				  return retryCount + 1;
				}, 0),
				tap(retryCount => console.log(`Reintento ${retryCount} fallido. Intentando nuevamente...`)),
				// Espera 1 segundo antes de reintentar
				delay(1000)
			  )
			),
			catchError(error => {
			  console.error('Error final en Getimglogin:', error);
			  return throwError(error);
			})
		  );
		
	}

	loadimgloggin(): Observable<any[]> {
		this.isLoadingSubject.next(true);
		return this.http.get<ActionResult<any[]>>(`${this.configService.config.apiSecuritySeven}/themes/Getimglogin`)
		  .pipe(
			// Reintentar hasta 2 veces adicionales en caso de error
			retryWhen(errors =>
			  errors.pipe(
				scan((retryCount, err) => {
				  if (retryCount >= 2) {
					throw err;
				  }
				  return retryCount + 1;
				}, 0),
				tap(retryCount => console.log(`Intento de reintento ${retryCount} fallido. Reintentando...`)),
				delay(1000)
			  )
			),
			catchError(err => {
			  // Notifica el error y retorna un observable con un arreglo vacío (o puedes retornar null)
			  this.messagesService.error("Error conectando con el servidor de seguridad");
			  return of([]);
			}),
			map((resp: ActionResult<any[]>) => resp.result),
			finalize(() => this.isLoadingSubject.next(false))
		  );
	  }
	
	// loadimgloggin(): Observable<any[]> {
	// 	this.isLoadingSubject.next(true);
	// 	return this.http.get<ActionResult<any[]>>(`${this.configService.config.apiSecuritySeven}/themes/Getimglogin`)
	// 	  .pipe(
	// 		catchError(err => of(
	// 		  this.messagesService.error("Error conectando con el servidor de seguridad"))),
	// 		map((resp: ActionResult<any[]>) => {
	// 		  return resp.result;
	// 		}),
	// 		finalize(() => this.isLoadingSubject.next(false))
	// 	  );

		  
	//   }
	
	Getdatainsta(){
		return this.http.get<ActionResult<any>>(
			`${this.configService.config.apiSecuritySeven}/Getdatainsta`
		);
		
	}

	generate(){
		return this.http.get<TOTransaction<any>>(
			`${this.configService.config.apicaptcha}/RCAPTCHA/Generate`
		);
	}
	
	validate(captchaData: CaptchaData) {

		let direccion = this.configService.config.apicaptcha+"/RCAPTCHA/validate";
		return this.http.post<any>(direccion,captchaData);
	
	  }

	// CREATE =>  POST: add a new user to the server
	createUser(user: UserModel): Observable<UserModel> {
		return this.http.post<UserModel>(
			`${this.configService.config.apiSecuritySeven}`,
			user
		);
	}

	// Your server should check email => If email exists send link to the user and return true | If email doesn't exist return false
	forgotPassword(email: string): Observable<ActionResult<any>> {
		return this.http.get<ActionResult<any>>(
			`${this.configService.config.apiSecuritySeven}/forgotpassword/recover?email=${email}`
		);
	}

	resetPassword(resetPass: resetpassword): Observable<ActionResult<any>> {
		const httpHeaders = new HttpHeaders({
			Authorization: `Bearer ${resetPass.token}`,
		});
		return this.http.post<ActionResult<any>>(
			`${this.configService.config.apiSecuritySeven}/forgotpassword/update`,
			resetPass,
			{
				headers: httpHeaders,
			}
		);
		// return this.http.post<boolean>(`${this.configService.config.apiSecuritySeven}/UpdatePassword`, resetPass).pipe(map(resp=>{

		//  console.log("estass",resp);
		//   return resp;

		// }))
	}



	refresh(token:any): Observable<ActionResult<AuthModel>> {
		const httpHeaders = new HttpHeaders({
			Authorization: `Bearer ${token}`,
		});
		return this.http.post<ActionResult<AuthModel>>(
			`${this.configService.config.apiSecuritySeven}/refresh`,
			{
				headers: httpHeaders,
			}
		);
	}

	getUserByToken(tokes:any): Observable<ActionResult<UserModel>> {
		return this.http.get<ActionResult<UserModel>>(
			`${this.configService.config.apiSecuritySeven}/user`
		);
	}
	getUserProfile(user: string) {
		return this.http.get<ActionResult<any>>(
			`${this.configService.config.apiSecuritySeven}/user/getphoto?user=${user}`
		);
	}

	getUserProfiles(user: string): Observable<ActionResult<any>> {
		return this.http.get<ActionResult<any>>(`${this.configService.config.apiSecuritySeven}/user/getphoto?user=${user}`);
	  }


	getUserlogo(emp_codi: string) {
		return this.http.get<ActionResult<any>>(
			`${this.configService.config.apiSecuritySeven}/user/getphotologo?emp_codi=${emp_codi}`
		);
	}
	getUserlogodefaul() {
		return this.http.get<ActionResult<any>>(
			`${this.configService.config.apiSecuritySeven}/user/getphotologodefaul`
		);
	}

	refreshToken() {
		return this.http
			.post<ActionResult<any>>(
				`${this.configService.config.apiSecuritySeven}/refresh`,
				{}
			)
			.pipe(
				map((user) => {
					return user.result;
				})
			);
	}

	refreshCompanyToken(companyCode: number) {
		return this.http
			.post<ActionResult<any>>(
				`${this.configService.config.apiSecuritySeven}/security/changeCompany`,
				{ Emp_Codi: companyCode }
			)
			.pipe(
				map((user) => {
					return user.result;
				})
			);
	}

	 validateSsoToken(token: string,code:string){
		return this.http
			.post<ActionResult<any>>(
				`${this.configService.config.apiSecuritySeven}/sso`,
				{ token,code }
			)
			.pipe(
				map((user: ActionResult<any>) => {
					if (!user.isSuccessful) throw user.errorMessage;
					return user; 
				})
			);
	}

	public validatedMicroApp(code:string) :Observable<ActionResult<any>> {
		return this.http.get<ActionResult<any>>(`${this.configService.config.apiSecuritySeven}/validatedMicroApp?code=${code}`);
		}

		validarToken(token: TokenRequest) {
			console.log("TokenRequest",TokenRequest);
			
			return this.http
				.post<ActionResult<any>>(
					`${this.configService.config.apiSecuritySeven}/ValidarRECaptcha`,
					token, // Cambia aquí, envía el token como un string plano
					{ headers: { 'Content-Type': 'application/json' } } // Asegúrate de establecer el encabezado correctamente
				)
				.pipe(
					map((respon: ActionResult<any>) => {
						if (!respon.isSuccessful) throw respon.errorMessage;
						return respon;
					})
				);
		}		



		public	generateQRCode(identifier:String) {


			return this.http.get<TOTransaction<any>>(
				`${this.configService.config.apiSecuritySeven}/generate-qr?identifier=${identifier}`);
		  }
		  public  validate2fa(code:string,secret:string) {

			return this.http.post<TOTransaction<any>>(
				`${this.configService.config.apiSecuritySeven}/validate-2fa`, { code: code, secret: secret });
		  }

		
		  public validatelicense () {
                 return this.http.get<ActionResult<any>>(
				`${this.configService.config.apiSecuritySeven}/user/GetLicencia`);
		  }

		  public ControlLicenciamiento(user:string,password:string,ctr_inic:string) :Observable<ActionResult<any>> {
			return this.http.get<ActionResult<any>>(`${this.configService.config.apiSecuritySeven}/user/ControlLicenciamiento?user=${user}&password=${password}&ctr_inic=${ctr_inic}`);
			}
}
